import { render, staticRenderFns } from "./tab_data_mentah.vue?vue&type=template&id=36db217b&scoped=true"
import script from "./tab_data_mentah.vue?vue&type=script&lang=js"
export * from "./tab_data_mentah.vue?vue&type=script&lang=js"
import style0 from "./tab_data_mentah.vue?vue&type=style&index=0&id=36db217b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36db217b",
  null
  
)

export default component.exports